import { render, staticRenderFns } from "./CongressInfoCard.vue?vue&type=template&id=4a6ad4bc"
import script from "./CongressInfoCard.vue?vue&type=script&lang=js"
export * from "./CongressInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports